import auth from '@/api/auth';
import store from '@/store';

function multiguards(guards) {
  return async (to, from, next) => {
    // a flag to discard remaining guards
    let changed = false;

    // handle next for multiple guards
    // eslint-disable-next-line func-names
    const mNext = function (value) {
      // prevent calling next after it is already resolved with a value
      if (changed) return;

      // if we have 'value' reslove next with the value and set changed flag
      if (typeof value !== 'undefined') {
        changed = true;
        next(value);
      }
    };

    // call guards
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < guards.length; i++) {
      if (changed) break;
      // eslint-disable-next-line no-await-in-loop
      await guards[i](to, from, mNext);
    }

    // move on if none of guards resolved next with a value
    if (!changed) next();
  };
}

/*
 * Athuga hvort innskráning sé ekki til eða
 * er útrunnin.
 */
const checkExpired = (token, next) => {
  if (!token || auth.isTokenExpired()) {
    next({ name: 'LoginToken' });
    return true;
  }

  return false;
};

const doRequireAuth = (to, from, next) => {
  const token = auth.getToken();

  if (checkExpired(token, next)) {
    return Promise.reject(new Error('No valid auth token'));
  }

  const q = [];

  if (store.state.loggedInUser == null) {
    q.push(store.dispatch('getLoggedInUser'));
  }

  return Promise.all(q)
    .then(() => {})
    .catch(() => {})
    .then(() => {
      next();
    });
};

const canRead = (to, from, next) => {
  if (!store.state.loggedInUser || store.state.loggedInUser.can_read !== 1) {
    next({ path: '/' });
    return;
  }

  next();
};

const canEdit = (to, from, next) => {
  if (!store.state.loggedInUser || store.state.loggedInUser.can_edit !== 1) {
    next({ path: '/' });
    return;
  }

  next();
};
/* ADA: símmenntunarviðbót : bæta við master */
const isAdmin = (to, from, next) => {
  if (!store.state.loggedInUser || (store.state.loggedInUser.is_master_admin !== 1 && store.state.loggedInUser.is_admin !== 1)) {
    next({ path: '/' });
    return;
  }

  next();
};

const canCreateBook = (to, from, next) => {
  if (!store.state.loggedInUser || store.state.loggedInUser.can_create_book !== 1) {
    next({ path: '/' });
    return;
  }

  next();
};

const canViewStatistics = (to, from, next) => {
  if (store.state.loggedInUser?.can_view_statistics !== 1) {
    next({ path: '/' });
    return;
  }
  next();
};

export default {
  multiguards,
  canRead,
  canEdit,
  isAdmin,
  canCreateBook,
  canViewStatistics,
  /**
   * Krefjast innskráningar.
   */
  requireAuth(to, from, next) {
    return doRequireAuth(to, from, next);
  },
  /**
   * Skrá út fyrst
   */
  logoutBefore(to, from, next) {
    auth.removeToken();
    store.dispatch('doClean');
    next();
  },
};
